
const SearchBar = new Vue({
	// SearchBar Element ~> this.$el
	el: '#SearchBar',
	data: {
		showTopicLink: false,
		searchInput: '',
	},
	mounted: function() {
		const self = this;
	},
	methods: {

		showTopic: function() {
			this.showTopicLink = true;
		},
		hideTopic: function() {
			this.showTopicLink = false;
		},
		runSearch: function() {
			const self = this;
			self.$refs.searchBarForm.submit();
		},
	}
});



// WEBPACK FOOTER //
// ../components/utility/utility.js